module.exports = __webpack_public_path__ + "media/images/icons/instagram-6b35a5a9c2d514c8072a95364b5cedbf.svg";